import { MutationKey, QueryKey } from '@tanstack/react-query';

import { services2 } from '/api/services2';

export const appsInventoryQueryKeys: QueryKey = ['apps', 'inventory', 'query'];

export const { appsInventoryService } = services2;
export const appsInventoryServiceName: string = appsInventoryService.getClassName();

export const createItemMutationKey: MutationKey = ['inventory', 'item', 'create'];
export const updateItemMutationKey: MutationKey = ['inventory', 'item', 'update'];
export const removeItemMutationKey: MutationKey = ['inventory', 'item', 'remove'];
export const appsInventoryRetrieveKeys: unknown[] = ['apps', 'inventory', 'retrieve'];
export const appsInventoryPromotionsRetrieveKeys: unknown[] = ['apps', 'inventory', 'promotions', 'retrieve'];
export const appsInventoryCheckKeys: unknown[] = ['apps', 'inventory', 'item', 'check'];
